import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _doctorListByBranch;

import { OrgID } from 'src/types';
/**
 * @deprecated This doctor list will be replaced by `useUserByRole` hook in the future.
 *
 * Current status:
 * - Still in use in some components
 * - Replacement timeline undetermined
 *
 * Guidelines:
 * - Update this map as needed
 * - For new code, prefer `useUserByRole` hook
 *
 * @see {useUserByRole} for future alternative
 */

export var DoctorList = {
  tw: [{
    id: 5070,
    name: '宋晏仁'
  }, {
    id: 6627,
    name: '鄧雯心'
  }, {
    id: 7358,
    name: '周建安'
  }, {
    id: 7338,
    name: '李唐越'
  }, {
    id: 7739,
    name: '吳榛槿'
  }, {
    id: 8028,
    name: '許芷瑜'
  }, {
    id: 8377,
    name: '魏士航'
  }, {
    id: 8869,
    name: '李思賢'
  }, {
    id: 8868,
    name: '吳銘鋐'
  }, {
    id: 9854,
    name: '黃致遠'
  }, {
    id: 9855,
    name: '楊智雯'
  }, {
    id: 10360,
    name: '陳威龍'
  }],
  cn: [{
    id: 3303,
    name: '宋晏仁'
  }, {
    id: 3417,
    name: '石璐'
  }]
};
/**
 * @deprecated This doctor map will be replaced by `useUserByRole` hook in the future.
 *
 * Current status:
 * - Still in use in some components
 * - Replacement timeline undetermined
 *
 * Guidelines:
 * - Update this map as needed
 * - For new code, prefer `useUserByRole` hook
 *
 * @see {useUserByRole} for future alternative
 */

export var doctorListByBranch = (_doctorListByBranch = {}, _defineProperty(_doctorListByBranch, OrgID.Cofit, []), _defineProperty(_doctorListByBranch, OrgID.Cymbal, ['魏士航', '許芷瑜']), _defineProperty(_doctorListByBranch, OrgID.Cymbalxinlin, ['魏士航', '許芷瑜']), _defineProperty(_doctorListByBranch, OrgID.FCLab, []), _defineProperty(_doctorListByBranch, OrgID.Genesis, ['宋晏仁', '鄧雯心', '周建安', '李唐越', '許芷瑜', '魏士航', '李思賢', '陳威龍']), _defineProperty(_doctorListByBranch, OrgID.GenesisHC, ['魏士航', '宋晏仁', '吳榛槿', '陳威龍', '楊智雯']), _defineProperty(_doctorListByBranch, OrgID.GenesisKH, ['宋晏仁', '鄧雯心', '周建安', '李唐越', '許芷瑜', '魏士航', '李思賢', '楊智雯']), _defineProperty(_doctorListByBranch, OrgID.Lumez, ['宋晏仁', '吳榛槿', '李唐越', '吳銘鋐', '許芷瑜', '黃致遠', '楊智雯']), _defineProperty(_doctorListByBranch, OrgID.LumezGenesis, ['宋晏仁', '吳榛槿', '李唐越', '吳銘鋐', '許芷瑜', '黃致遠', '楊智雯']), _defineProperty(_doctorListByBranch, OrgID.Testing, ['宋晏仁', '鄧雯心', '周建安', '李唐越', '許芷瑜', '魏士航', '李思賢']), _defineProperty(_doctorListByBranch, OrgID.Tianyi, ['石璐', '宋晏仁']), _defineProperty(_doctorListByBranch, OrgID.YouCofitHQ, []), _doctorListByBranch);
export var getDoctorList = function getDoctorList(doctorNames, type) {
  return doctorNames.map(function (name) {
    return DoctorList[type].find(function (doctor) {
      return name === doctor.name;
    });
  });
};